<template>
  <div class="section-info">
    <h1 class="section-info__title">{{ title }}</h1>
    <p class="section-info__text">
      {{ text }}
      <BaseLink v-if="linkUrl" :to="linkUrl" v-html="linkLabel"></BaseLink>
    </p>
    <slot name="button">
      
    </slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      text: String,
      linkUrl: String,
      linkLabel: {
        type: String,
        default: 'Learn&nbsp;more.'
      }
    },
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';

  .section-info {
    padding-right: 64px;
    margin-bottom: 28px;

    &__title {
      margin-top: 12px;
      font-size: 17px;
      font-weight: 600;
      line-height: 1.5;
    }

    &__text {
      margin-top: 16px;
      color: $color-pale-sky;
      font-size: 14.6px;
      line-height: 1.43;
    }

    button {
      margin-top: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/SectionInfo.vue